(() => {
  const checkboxSelector = '[data-cart-terms-checkbox]';
  const defaultAlertMessage = 'Du skal acceptere vores handelsbetingelser for at kunne betale';

  const getTermsElements = (checkbox) => {
    const terms = checkbox.closest('[data-cart-terms]');
    const actions = terms?.nextElementSibling?.matches('[data-cart-terms-actions]')
      ? terms.nextElementSibling
      : terms?.parentElement?.querySelector('[data-cart-terms-actions]');
    const checkout = actions?.querySelector('[data-cart-terms-checkout]');
    const dynamicCheckout = actions?.nextElementSibling?.matches('[data-cart-terms-dynamic-checkout]')
      ? actions.nextElementSibling
      : terms?.parentElement?.querySelector('[data-cart-terms-dynamic-checkout]');

    return { terms, checkout, dynamicCheckout };
  };

  const updateTermsState = (checkbox) => {
    const { checkout, dynamicCheckout } = getTermsElements(checkbox);
    const cartIsEmpty = checkout?.dataset.cartEmpty === 'true';
    const accepted = checkbox.checked;

    // Keep checkout clickable; only disable when the cart is empty.
    if (checkout) checkout.disabled = cartIsEmpty;
    // Hide express buttons until terms are accepted (they bypass the form).
    if (dynamicCheckout) dynamicCheckout.hidden = !accepted || cartIsEmpty;
  };

  const findCheckboxForCheckout = (checkoutButton) => {
    return document.querySelector(
      checkoutButton.getAttribute('form') === 'cart'
        ? '#main-cart-footer [data-cart-terms-checkbox]'
        : '#mini-cart [data-cart-terms-checkbox]'
    );
  };

  const requireTermsAcceptance = (checkoutButton) => {
    const checkbox = findCheckboxForCheckout(checkoutButton);
    if (!checkbox || checkbox.checked) return true;

    const terms = checkbox.closest('[data-cart-terms]');
    const alertMessage = terms?.dataset.cartTermsAlert?.trim() || defaultAlertMessage;

    window.alert(alertMessage);
    checkbox.focus();
    return false;
  };

  const initializeTerms = (root = document) => {
    root.querySelectorAll(checkboxSelector).forEach(updateTermsState);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches(checkboxSelector)) updateTermsState(event.target);
  });

  document.addEventListener('submit', (event) => {
    const checkoutButton = event.submitter?.matches('[data-cart-terms-checkout]')
      ? event.submitter
      : null;
    if (!checkoutButton) return;

    if (!requireTermsAcceptance(checkoutButton)) {
      event.preventDefault();
    }
  });

  document.addEventListener('cart:updated', () => initializeTerms());
  initializeTerms();
})();
